/**
 * Extracts error message from Axios error response or returns default message
 * @param {Error} error - The error object from a catch block
 * @param {string} defaultMessage - Default message to return if no specific error message is found
 * @returns {string} - The appropriate error message
 */
export const getAxiosErrorMessage = (error, defaultMessage = "An error occurred") => {
  // Check if it's an Axios error with a response
  if (error.response && error.response.data) {
    // Check for message in common response formats
    if (error.response.data.message) {
      return error.response.data.message;
    }

    // Some APIs might use 'error' property instead of 'message'
    if (error.response.data.error) {
      return error.response.data.error;
    }

    // If data is a string, return it directly
    if (typeof error.response.data === 'string') {
      return error.response.data;
    }
  }

  // If error has a message property (standard JS Error)
  if (error.message && error.message !== 'Network Error') {
    return error.message;
  }

  // Return default message if no specific error message found
  return defaultMessage;
};
